/**
 * Яндекс Метрика скриптом счётчика (вместо ng-yandex-metrika: пакет не
 * поддерживает новые Angular). Только сборка с [id] — prod
 */
export function loadMetrika(id: number | null | undefined): void {
  if (!id) return;
  const w = window as unknown as {ym?: ((...args: unknown[]) => void) & {a?: unknown[]; l?: number}};
  w.ym = w.ym || function (...args: unknown[]) {
    (w.ym!.a = w.ym!.a || []).push(args);
  };
  w.ym.l = Date.now();
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://mc.yandex.ru/metrika/tag.js';
  document.head.appendChild(script);
  w.ym(id, 'init', {clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: true});
}
